<template>
  <vs-popup :title="$t('teacher.titles')" :active.sync="visible" id="popup-teacher" @close="closePopup" ref="vspopup-teacher">
    <!-- `v-if="visible"`: o vs-popup renderiza o conteúdo mesmo fechado, então
         esta grade consultava /teachers/grid em toda montagem da tela que a
         contém — uma busca que ninguém pediu, e um 403 para quem não tem a
         permissão, no meio de um formulário que o usuário estava preenchendo. -->
    <Grid
        v-if="visible"
        ref="grid-teacher-popup"
        :multipleSelect="true"
        :service="teacherService"
        @changedSelection="changedSelection"
        route_name="teachers"
        hide_actions="true"
        order_column="teacher_name"
        :request-params="filtersGrid"
        :columnDataKeys="{
          'ppl.people_view.name': 'teacher_name',
          'ppl.people_view.email': 'teacher_email'
        }">
    </Grid>
      <!--:request-params="applyFiltersGrid"-->
    <div class="flex flex-row justify-end gap-4">
        <b-button
          @click="addTeachers"
          variant="primary"
          icon="add">
          {{ $t('adicionar') }}
        </b-button>
    </div>
  </vs-popup>
</template>

<script>
import TeacherService from '@/services/api/TeacherService'

import {
BButton
} from 'bootstrap-vue'

export default {
components: {
  BButton
},
props: {
  visible :{
    type: Boolean,
    default: false
  },
  filters :{
    type: String,
    default: null
  }
},
data: () => ({
  teacherService: null,
  selectedTeachers: []
}),
computed: {
  filtersGrid(){
    return this.filters
  }
},
methods: {
  changedSelection(items) {
    this.selectedTeachers = items
  },
  itemSelected(teacher) {
    const teacherIndex = this.selectedTeachers.findIndex((_teacher) => _teacher === teacher.id)

    if (teacherIndex !== -1) {
      const newArray = this._.cloneDeep(this.selectedTeachers)
      newArray.splice(teacherIndex, 1)
      this.selectedTeachers = newArray
    } else {
      this.selectedTeachers.push(teacher.id)
    }
  },
  addTeachers() {
    this.$emit('selected', [...this.selectedTeachers])
    this.$emit('close', false)
  },
  closePopup(value){
    this.$emit('close', value)
  },
  applyFiltersGrid(){
    if(this.filters){
      this.getGrid().fillCustomFilters(this.filters)
      this.getGrid().fetchGridData(false)
    }
  },
  getGrid(){
    const gripP = this.$refs['grid-teacher-popup']
    return gripP
  }
},
beforeMount() {
  this.teacherService = TeacherService.build(this.$vs)
},
mounted() {

},
watch: {
  visible(val){
    if(val){
      //this.applyFiltersGrid()
    }
  }
},
}
</script>


<style lang="scss" scoped>
::v-deep .vs-popup {
  width: 800px !important;
}
</style>
